import auth from '../../middlewares/auth';

export const typeRoutes = [
  {
    path: '/types',
    component: () =>
      import(
        /* webpackChunkName: "types" */ '../../views/inventory/types/Index'
      ),
    name: 'types',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-type-manage'],
    },
  },
  {
    path: '/types/:id',
    component: () =>
      import(
        /* webpackChunkName: "types" */ '../../views/inventory/types/Form'
      ),
    name: 'update-types',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-type-manage'],
    },
  },
  {
    path: '/create-types',
    component: () =>
      import(
        /* webpackChunkName: "types" */ '../../views/inventory/types/Form'
      ),
    name: 'create-types',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-type-manage'],
    },
  },
];
